import { KeyValue } from '@/main/models/common';
import { MunicipalityActionTypes, MunicipalityTypes } from './municipalityTypes';
import { MunicipalityFilterRequest } from '@/main/models/request';

export function getMunicipality(request: MunicipalityFilterRequest): MunicipalityActionTypes {
  return {
    type: MunicipalityTypes.GET_MUNICIPALITY,
    payload: { request }
  };
}

export function saveMunicipality(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): MunicipalityActionTypes {
  return {
    type: MunicipalityTypes.SAVE_MUNICIPALITY,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerMunicipality(): MunicipalityActionTypes {
  return {
    type: MunicipalityTypes.RESET_REDUCER_MUNICIPALITY
  };
}
